<template>
	<section>

		<MainBar
			title="Writer"
		></MainBar>

		<div class="card">
			<p>
				<label class="row">
					<input v-model="Store.doc.name" type="text" name="name"/>
					<span>{{ Store.l.name }}</span>
				</label>
			</p>
			<p>
				<label class="row">
					<input v-model="Store.doc.title" type="text" name="title"/>
					<span>{{ Store.l.title }}</span>
				</label>
			</p>
			<p>
				<label class="row">
					<input type="text" readonly :value="summary"/>
					<span>{{ Store.l.summary }}</span>
				</label>
			</p>
			<p>
				<label class="row">
					<input type="text" readonly :value="Store.formatTimestamp(Store.doc.create_ts)"/>
					<span>{{ Store.l.creation_date }}</span>
				</label>
			</p>
			<p>
				<label class="row">
					<input type="text" readonly :value="Store.formatTimestamp(Store.doc.update_ts)"/>
					<span>{{ Store.l.last_edit }}</span>
				</label>
			</p>
			<small style="margin: 0 0 -1rem .5rem; display: block;">{{ Store.l.note }}</small>
			<NoteEditor :item=Store.doc></NoteEditor>
		</div>

		<div class="card" v-if="Store.settings">
			<h3>{{ Store.l.server }}</h3>
			<div v-if="Store.meta.serverUUID && Store.meta.serverPath">
				<p>
					<router-link :to="{ path: '/settings/webdav/'+Store.meta.server }">
						<i class="mdi mdi-server"></i>
						<b>{{ Store.settings.servers.get(Store.meta.serverUUID).name }}</b>
					</router-link>
					<router-link :to="{ path: '/folder', query: { server: Store.meta.serverUUID } }">
						/{{ Store.meta.serverPath }}
					</router-link>
				</p>
			</div>
			<form v-else-if="Store.settings.servers.size" @submit.prevent="getServerFolder">
				<p>
					<label class="row">
						<select v-model="Store.meta.serverUUID" required>
							<option v-for="[k, v] in Store.settings.servers" :key="k" :value="v.uuid">{{ v.name }}</option>
						</select>
						<span>{{ Store.l.server }}</span>
					</label>
				</p>
				<p class="text-right">
					<button type="submit">{{ Store.l.choose_folder }}</button>
				</p>
			</form>
			<div v-else>
				<p class="text-center">
					<i>{{ Store.l.no_server_configured }}</i>
				</p>
				<p class="text-right">
					<router-link to="/settings" class="button">{{ Store.l.settings }}</router-link>
				</p>
			</div>
		</div>

	</section>
</template>

<script>

import MainBar from "@/components/MainBar.vue"
import NoteEditor from '../components/NoteEditor.vue'

import Store from "@/Store.js"

export default {
	data: () => ({
		Store,
	}),
	components: { MainBar, NoteEditor },
	computed: {
		summary: {
			get() {
				let scenes = 0, paragraphs = 0, words = 0, characters = 0;

				let sections = this.Store.doc.section.length;
				this.Store.doc.section.forEach(section => {
					scenes += section.scene.length;
					paragraphs += section.countParagraphs();
					words += section.countWords();
					characters += section.countCharacters();
				});

				return `${sections} Sezioni — ${scenes} Scene — ${paragraphs} Paragrafi — ${words} Parole — ${characters} Battute`;
			}
		}
	},
	methods: {
		onAction(action) {
			switch(action) {
				case "fileNew":
					this.Store.fileNew();
					break;
				case "fileOpen":
					this.Store.docOpen();
					break;
				case "fileSave":
					this.Store.docSave();
					break;
			}
		},

		getServerFolder() {
			this.$router.push({ path: "/folder", query: { server: Store.meta.serverUUID } });
		}
	},
}

</script>
